import { render, staticRenderFns } from "./logisticsSystem.vue?vue&type=template&id=6b2ae9d8&scoped=true&"
import script from "./logisticsSystem.vue?vue&type=script&lang=js&"
export * from "./logisticsSystem.vue?vue&type=script&lang=js&"
import style0 from "./logisticsSystem.vue?vue&type=style&index=0&id=6b2ae9d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ae9d8",
  null
  
)

export default component.exports